export enum Language {
  FR = 'fr',
  EN = 'en',
  ES = 'es',
  DE = 'de',
  IT = 'it'
}

// Type pour les codes de langue supportés
export type LanguageCode = 'fr' | 'en' | 'es' | 'de' | 'it';

// Type pour les options de langue dans l'interface
export interface LanguageOption {
  code: LanguageCode;
  name: string;
  flag: string;
}

// Options de langue disponibles dans l'application
export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' }
];
